const LOCALE_COUNTRIES = {
    'ar': {
        localeName: 'Arabic',
        defaultCountry: 'Saudi Arabia',
        countryCode: 'SA',
    },
    'ca': {
        localeName: 'Catalan, Valencian',
        defaultCountry: 'Spain',
        countryCode: 'ES',
    },
    'zh_cn': {
        localeName: 'Chinese (simplified)',
        defaultCountry: 'China',
        countryCode: 'CN',
    },
    'zh': {
        localeName: 'Chinese (simplified)',
        defaultCountry: 'China',
        countryCode: 'CN',
    },
    'zh_tw': {
        localeName: 'Chinese (traditional)',
        defaultCountry: 'Taiwan',
        countryCode: 'TW',
    },
    'hr': {
        localeName: 'Croatian',
        defaultCountry: 'Croatia',
        countryCode: 'HR',
    },
    'cs': {
        localeName: 'Czech',
        defaultCountry: 'Czech Republic',
        countryCode: 'CZ',
    },
    'da': {
        localeName: 'Danish',
        defaultCountry: 'Denmark',
        countryCode: 'DK',
    },
    'nl': {
        localeName: 'Dutch',
        defaultCountry: 'Netherlands',
        countryCode: 'NL',
    },
    'en_au': {
        localeName: 'English',
        defaultCountry: 'Australia',
        countryCode: 'AU',
    },
    'en_ca': {
        localeName: 'English',
        defaultCountry: 'Canada',
        countryCode: 'CA',
    },
    'en_gb': {
        localeName: 'English',
        defaultCountry: 'United Kingdom',
        countryCode: 'GB',
    },
    'en': {
        localeName: 'English',
        defaultCountry: 'United States',
        countryCode: 'US',
    },
    'fi': {
        localeName: 'Finnish',
        defaultCountry: 'Finland',
        countryCode: 'FI',
    },
    'fr': {
        localeName: 'French',
        defaultCountry: 'France',
        countryCode: 'FR',
    },
    'fr_ca': {
        localeName: 'French',
        defaultCountry: 'Canada',
        countryCode: 'CA',
    },
    'de': {
        localeName: 'German',
        defaultCountry: 'Germany',
        countryCode: 'DE',
    },
    'el': {
        localeName: 'Greek (modern)',
        defaultCountry: 'Greece',
        countryCode: 'GR',
    },
    'he': {
        localeName: 'Hebrew',
        defaultCountry: 'Israel',
        countryCode: 'IL',
    },
    'hi': {
        localeName: 'Hindi',
        defaultCountry: 'India',
        countryCode: 'IN',
    },
    'hu': {
        localeName: 'Hungarian',
        defaultCountry: 'Hungary',
        countryCode: 'HU',
    },
    'id': {
        localeName: 'Indonesian',
        defaultCountry: 'Indonesia',
        countryCode: 'ID',
    },
    'it': {
        localeName: 'Italian',
        defaultCountry: 'Italy',
        countryCode: 'IT',
    },
    'ja': {
        localeName: 'Japanese',
        defaultCountry: 'Japan',
        countryCode: 'JP',
    },
    'ko': {
        localeName: 'Korean',
        defaultCountry: 'Korea (South)',
        countryCode: 'KR',
    },
    'ms': {
        localeName: 'Malay',
        defaultCountry: 'Malaysia',
        countryCode: 'MY',
    },
    'nb': {
        localeName: 'Norwegian',
        defaultCountry: 'Norway',
        countryCode: 'NO',
    },
    'pl': {
        localeName: 'Polish',
        defaultCountry: 'Poland',
        countryCode: 'PL',
    },
    'pt_br': {
        localeName: 'Portuguese',
        defaultCountry: 'Portugal',
        countryCode: 'BR',
    },
    'pt': {
        localeName: 'Portuguese',
        defaultCountry: 'Portugal',
        countryCode: 'PT',
    },
    'ro': {
        localeName: 'Romanian',
        defaultCountry: 'Romania',
        countryCode: 'RO',
    },
    'ru': {
        localeName: 'Russian',
        defaultCountry: 'Russian Terrorists',
        countryCode: 'RU',
    },
    'sk': {
        localeName: 'Slovak',
        defaultCountry: 'Slovakia',
        countryCode: 'SK',
    },
    'es_mx': {
        localeName: 'Spanish',
        defaultCountry: 'Mexico',
        countryCode: 'MX',
    },
    'es': {
        localeName: 'Spanish',
        defaultCountry: 'Spain',
        countryCode: 'ES',
    },
    'sv': {
        localeName: 'Swedish',
        defaultCountry: 'Sweden',
        countryCode: 'SE',
    },
    'th': {
        localeName: 'Thai',
        defaultCountry: 'Thailand',
        countryCode: 'TH',
    },
    'tr': {
        localeName: 'Turkish',
        defaultCountry: 'Turkey',
        countryCode: 'TR',
    },
    'uk': {
        localeName: 'Ukrainian',
        defaultCountry: 'Ukraine',
        countryCode: 'UA',
    },
    'vi': {
        localeName: 'Vietnamese',
        defaultCountry: 'Vietnam',
        countryCode: 'VN',
    },
    'af': {
        localeName: 'Afrikaans',
        defaultCountry: 'South Africa',
        countryCode: 'ZA',
    },
    'am': {
        localeName: 'Amharic',
        defaultCountry: 'Ethiopia',
        countryCode: 'ET',
    },
    'az': {
        localeName: 'Azeri',
        defaultCountry: 'Azerbaijan',
        countryCode: 'AZ',
    },
    'be': {
        localeName: 'Belarusian',
        defaultCountry: 'Belarus',
        countryCode: 'BY',
    },
    'bg': {
        localeName: 'Bulgarian',
        defaultCountry: 'Bulgaria',
        countryCode: 'BG',
    },
    'bn': {
        localeName: 'Bangla',
        defaultCountry: 'Bangladesh',
        countryCode: 'BD',
    },
    'en_in': {
        localeName: 'English (India)',
        defaultCountry: 'India',
        countryCode: 'IN',
    },
    'en_sg': {
        localeName: 'English (Singapore)',
        defaultCountry: 'Singapore',
        countryCode: 'SG',
    },
    'en_za': {
        localeName: 'English (South Africa)',
        defaultCountry: 'South Africa',
        countryCode: 'ZA',
    },
    'es_419': {
        localeName: 'Spanish (Latin America)',
        defaultCountry: 'Mexico',
        countryCode: 'MX',
    },
    'es_us': {
        localeName: 'Spanish (United States)',
        defaultCountry: 'United States',
        countryCode: 'US',
    },
    'et': {
        localeName: 'Estonian',
        defaultCountry: 'Estonia',
        countryCode: 'ET',
    },
    'eu_es': {
        localeName: 'Basque',
        defaultCountry: 'Spain',
        countryCode: 'ES',
    },
    'fa': {
        localeName: 'Persian',
        defaultCountry: 'Iran',
        countryCode: 'IR',
    },
    'fa_ir': {
        localeName: 'Persian (Iran)',
        defaultCountry: 'Iran',
        countryCode: 'IR',
    },
    'fa_ae': {
        localeName: 'Persian (United Arab Emirates)',
        defaultCountry: 'United Arab Emirates',
        countryCode: 'AE',
    },
    'fa_af': {
        localeName: 'Persian (Afghanistan)',
        defaultCountry: 'Afghanistan',
        countryCode: 'AF',
    },
    'fil': {
        localeName: 'Filipino',
        defaultCountry: 'Philippines',
        countryCode: 'PH',
    },
    'gl_es': {
        localeName: 'Galician',
        defaultCountry: 'Romania',
        countryCode: 'RO',
    },
    'gu': {
        localeName: 'Gujarati',
        defaultCountry: 'India',
        countryCode: 'IN',
    },
    'hy_am': {
        localeName: 'Armenian',
        defaultCountry: 'Armenia',
        countryCode: 'AM',
    },
    'is_is': {
        localeName: 'Icelandic',
        defaultCountry: 'Iceland',
        countryCode: 'IS',
    },
    'ka_ge': {
        localeName: 'Georgian',
        defaultCountry: 'Georgia',
        countryCode: 'GE',
    },
    'kk': {
        localeName: 'Kazakh',
        defaultCountry: 'Kazakhstan',
        countryCode: 'KZ',
    },
    'km_kh': {
        localeName: 'Khmer',
        defaultCountry: 'Cambodia',
        countryCode: 'KH',
    },
    'kn_in': {
        localeName: 'Kannada',
        defaultCountry: 'India',
        countryCode: 'IN',
    },
    'ky_kg': {
        localeName: 'Kyrgyz',
        defaultCountry: 'Kyrgyzstan',
        countryCode: 'KG',
    },
    'lo_la': {
        localeName: 'Lao',
        defaultCountry: 'Laos',
        countryCode: 'LA',
    },
    'lt': {
        localeName: 'Lithuanian',
        defaultCountry: 'Lithuanian',
        countryCode: 'lt',
    },
    'lv': {
        localeName: 'Latvian',
        defaultCountry: 'Latvia',
        countryCode: 'LV',
    },
    'ml_in': {
        localeName: 'Malayalam',
        defaultCountry: 'India',
        countryCode: 'IN',
    },
    'mn_mn': {
        localeName: 'Mongolian',
        defaultCountry: 'Mongolia',
        countryCode: 'MN',
    },
    'mr_in': {
        localeName: 'Marathi',
        defaultCountry: 'India',
        countryCode: 'IN',
    },
    'my_mm': {
        localeName: 'Burmese',
        defaultCountry: 'MM',
        countryCode: 'MM',
    },
    'mk_mk': {
        localeName: 'Macedonian',
        defaultCountry: 'Macedonia',
        countryCode: 'MK',
    },
    'ne_np': {
        localeName: 'Nepali',
        defaultCountry: 'Nepal',
        countryCode: 'NP',
    },
    'no': {
        localeName: 'Norwegian',
        defaultCountry: 'Norway',
        countryCode: 'NO',
    },
    'pa': {
        localeName: 'Punjabi',
        defaultCountry: 'Pakistan',
        countryCode: 'PK',
    },
    'si_lk': {
        localeName: 'Sinhala',
        defaultCountry: 'Sri Lanka',
        countryCode: 'LK',
    },
    'sl': {
        localeName: 'Slovenian',
        defaultCountry: 'Slovenia',
        countryCode: 'SI',
    },
    'sq': {
        localeName: 'Albanian',
        defaultCountry: 'Albania',
        countryCode: 'AL',
    },
    'sr': {
        localeName: 'Serbian',
        defaultCountry: 'Serbia and Montenegro',
        countryCode: 'RS',
    },
    'sw': {
        localeName: 'Swahili',
        defaultCountry: 'Kenia',
        countryCode: 'KE',
    },
    'ta_in': {
        localeName: 'Tamil',
        defaultCountry: 'India',
        countryCode: 'IN',
    },
    'te_in': {
        localeName: 'Telugu',
        defaultCountry: 'India',
        countryCode: 'IN',
    },
    'ur': {
        localeName: 'Urdu',
        defaultCountry: 'Pakistan',
        countryCode: 'PK',
    },
    'zh_hk': {
        localeName: 'Chinese (Hong Kong)',
        defaultCountry: 'Hong Kong',
        countryCode: 'HK',
    },
    'zu': {
        localeName: 'Zulu',
        defaultCountry: 'South Africa',
        countryCode: 'ZA',
    },
};
export function getLocaleCountryCode(locale) {
    let loweredLocale = locale?.toLowerCase();
    if (LOCALE_COUNTRIES[loweredLocale]) {
        let locale = LOCALE_COUNTRIES[loweredLocale];
        let localeFullName = locale.localeName;
        if (loweredLocale.includes('_')) {
            localeFullName += '(' + locale.defaultCountry + ')';
        }
        locale.localeFullName = localeFullName;

        return locale;
    }
    return null;
}